/**
 * @desc 平台店铺-列表查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlatformShopResponseDto>>;
export function request(
  params: API.basics.platformShop.getList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/platformShop/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
